import React from 'react';
import { Flex, Box, Text, Image } from '@chakra-ui/react';
import Tooltips from './Tooltips';

interface Props {
  data: any;
  phoneWidth: number;
}

const RedirectMenu: React.FC<Props> = ({ data }) => {
  const horizontalType = data.guidance_type ?? 1;
  const listType = data.type;
  return (
    <Box
      _hover={{ bg: 'gray.200' }}
      backgroundColor="gray.100"
      transition="150ms ease"
      position="relative"
      p={1}
      margin="5px 0 5px 0"
    >
      <>
        <Flex align="center">
          <Text fontWeight="bold" fontSize="lg" mr={2}>
            {data?.name}
          </Text>
          <Tooltips data={data} />
        </Flex>
        {!!data?.description && (
          <Text fontSize="xs" color="gray.400">
            {data.description}
          </Text>
        )}
      </>
      <Flex
        justify={horizontalType !== '0' ? 'left' : 'center'}
        direction={horizontalType !== '0' ? 'column' : 'row'}
        style={
          listType === 'tabs'
            ? {
                justifyContent: 'left',
              }
            : {}
        }
        p={4}
      >
        {data.items ? (
          // eslint-disable-next-line array-callback-return, consistent-return
          data.items.map((item: any) => {
            return (
              <Flex
                justifyContent="center"
                alignItems="center"
                style={
                  listType === 'card'
                    ? {
                        backgroundColor: '#fff',
                        paddingRight: 15,
                        paddingLeft: 15,
                        paddingTop: 3,
                        paddingBottom: 3,
                        borderRadius: 10,
                        marginBottom: 3,
                        width: 'fit-content',
                        marginRight: horizontalType === '0' ? 5 : 0,
                        marginLeft: horizontalType === '0' ? 5 : 0,
                      }
                    : {
                        marginBottom: 3,
                        marginRight: horizontalType === '0' ? 5 : 0,
                        marginLeft: horizontalType === '0' ? 5 : 0,
                      }
                }
              >
                {item?.file?.id && (
                  <Image
                    w="30px"
                    h="30px"
                    borderRadius="2px"
                    src={item?.file?.id ? item?.file?.url : undefined}
                  />
                )}

                <Text
                  key={item.id}
                  ml={1}
                  color={item?.text_color ? item.text_color : '#000'}
                >
                  {item.name}
                </Text>
              </Flex>
            );
          })
        ) : (
          <Text>Sem itens cadastrados</Text>
        )}
      </Flex>
    </Box>
  );
};

export default RedirectMenu;
